import {CURRENT_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  removeDepartments(department, domain) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        domain,
      }
    })
    return instCred.delete('/serviceproviderdepartment/many', { data: { ids: department } });
  },
  updateDepartments(department, domain) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        domain,
      }
    })
    return instCred.put('/serviceproviderdepartment/many', { department });
  },
  createDepartments(department,domain) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        domain,
      }
    })
    return instCred.post('/serviceproviderdepartment/many', { department });
  },
};



// WEBPACK FOOTER //
// ./src/api/ServiceProviderDepartment/api.js